module.exports = __webpack_public_path__ + "img/img-testimonial-logo-1@2x.f3e4da7.png";